import { InitialConfigDefault } from '../models/product-view-config.model';
import { MediaMonoProductAssets, MediaProductAssets, MediaProductView } from '../models/product-view-media.model';

import { MediasPublicConstants, MediasPublicModels } from '@features/products/medias';
import { ProductImagePublicFunctions } from '@features/products/product-images';
import { ProductVideoPublicFunctions } from '@features/products/product-videos';

export function getMediaProductView({
    showMediaCarousel,
    location,
    color,
    imageType,
    imageTypeAlternative,
    defaultImageType,
    options,
}: MediaProductView): MediaProductAssets {
    const productImagesLocation = location ?? InitialConfigDefault.location;
    const isRelatedProduct = productImagesLocation === MediasPublicConstants.PublicMediaLocationType.related_product;
    const locationDefault = MediasPublicConstants.PublicMediaLocationType.category_page;

    // reference product-images.use-case.ts:97
    let image = ProductImagePublicFunctions.getImageForProductView({
        color,
        productImagesLocation,
        locationDefault,
        imageType,
        imageTypeAlternative,
        defaultImageType,
        options,
    });

    let video: MediasPublicModels.PublicMediaResolved = null;

    if (image?.idMedia !== defaultImageType) {
        video = ProductVideoPublicFunctions.getVideoForProductView({
            color,
            productImagesLocation,
            locationDefault,
            defaultImageType,
            options,
        });

        if (isRelatedProduct && video?.location !== MediasPublicConstants.PublicMediaLocationType.related_product) {
            video = undefined;
        } else {
            const result = ProductVideoPublicFunctions.generateVideoPosterImage({
                video,
                image,
                discardVideos:
                options.discardVideos,
            });
            image = result.image;
            video = result.video;
        }
    }

    let productImages: MediasPublicModels.PublicMediaResolved[] = [];
    if (showMediaCarousel) {
        productImages = ProductImagePublicFunctions.getCarouselImages({
            color, location, imageType, image,
        });
    }

    return { image, video, productImages };
}

export function getMultipleMediaProductView({
    color,
    multipleMedias,
}: any): MediaMonoProductAssets {
    let images = ProductImagePublicFunctions.getMultipleMedias({
        color, mediaType: 'image', totalMedias: multipleMedias,
    });
    const videos = ProductImagePublicFunctions.getMultipleMedias({
        color, mediaType: 'video', totalMedias: multipleMedias,
    });

    images = images.map((image, index) => {
        const videoItem = videos[index];
        if (videoItem) {
            return ProductVideoPublicFunctions.generateVideoPosterImage({
                video: videoItem,
                image: videoItem,
                discardVideos: false,
            }).image;
        }
        return image;
    });

    return { images, videos, productImagesCarousel: [] };
}
